export enum AssignDataOwnerDialogOptions {
  WITH_EMAIL = 'withEmail',
  WITHOUT_EMAIL = 'withoutEmail',
}
